import { render, staticRenderFns } from "./CompanyInfoCard.vue?vue&type=template&id=2b86deb1&scoped=true"
import script from "./CompanyInfoCard.vue?vue&type=script&lang=js"
export * from "./CompanyInfoCard.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfoCard.vue?vue&type=style&index=0&id=2b86deb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b86deb1",
  null
  
)

export default component.exports